import React, { ReactNode } from 'react';

import { useGetFeatureEnabledForCountry } from '../common/hooks/useGetFeatureEnabledForCountry';

type Props = {
  children: ReactNode;
};

export default function GlintsVIPComponentWrapper({ children }: Props) {
  const { isVIPMembershipEnabled } = useGetFeatureEnabledForCountry();

  return isVIPMembershipEnabled ? <>{children}</> : null;
}
